import { AppButton, AppImages } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import * as AppPics from 'assets/images';
import Joi from 'joi';
import useAdminLogin from 'hooks/API/useAdminLogin';
import { notifier } from 'components/Toaster';
import useRegisterEmail from 'hooks/API/useRegisterEmail';
import Lottie from 'react-lottie-player';

function Login() {
  const authContext = useContext(AuthContext);
  const { mutate, isLoading } = useAdminLogin();
  const { mutate: saveEmail, isLoading: isSaving } = useRegisterEmail();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [registerEmail, setRegisterEmail] = useState('');

  function handleLogin() {
    authContext.clearAuthState();
    if (isLoading) return;

    const data = { email, password };

    const validator = loginSchema.validate(data, { abortEarly: false });

    if (validator?.error) {
      // console.log("### validator ERROR :: ", validator)
      return;
    }

    mutate(data, {
      onSuccess() {},
      onError(failData) {
        notifier.error(failData?.response.data.message);
      },
    });
  }

  function register() {
    if (!registerEmail) return;
    if (isSaving) return;

    const data = { email: `${registerEmail}`.toLowerCase().trim() };

    const validator = registerSchema.validate(data, { abortEarly: false });

    if (validator?.error) {
      // console.log('### validator ERROR :: REGISTER:: ', validator);
      return;
    }

    saveEmail(data);
  }

  if (authContext.isAuthenticated()) return <Redirect to="/console" />;

  return (
    <div className="container-fluid login_wrap">
      <div className="row login">
        <div className="col-md-6 login__imgSection">
          <AppImages
            className="login__imgSection-logo"
            alt="Login Logo"
            src={AppPics.LoginLogoSvg}
          />
        </div>

        <div
          className={`col-md-6 login__contentSection ${
            authContext.authState?.delayBeforeLoginSuccess ? `___auth_login` : ``
          }`}
        >
          <div className="login__contentSection-head">
            <h1>Welcome to edpodia backdoor!</h1>
            <h2>The super study lab we built together!</h2>
            <span>Key in below and enter inside …</span>
          </div>
          <div className={`login__contentSection-wrap`}>
            <form className="login__contentSection-wrapForm">
              <input
                type="text"
                name="username"
                placeholder="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <input
                type="password"
                name="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
              <a className="login__contentSection-wrapFormKey" href="/forgotPassword">
                Lost your keys?
              </a>
              <AppButton variantClass="btn-primary" onClick={handleLogin} disabled={isLoading}>
                Sign In
              </AppButton>
              <span>————— Or —————</span>
              <p>Raise a request for an account if you don’t have one?</p>
              <input
                placeholder="your email id that will be used for login … "
                type="email"
                value={registerEmail}
                onChange={(event) => setRegisterEmail(event.target.value)}
              />
              <AppButton variantClass="btn-primary" onClick={register} disabled={isSaving}>
                Request Account
              </AppButton>
              <span className="bottom_thick_line"></span>
            </form>
            <div className="___lock">
              <Lottie
                loop
                animationData={AppPics.Lottie_lock}
                play={!isLoading ? false : true}
                // play={authContext.authState?.delayBeforeLoginSuccess ? false : true}
                style={{ width: 150, height: 150 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const loginSchema = Joi.object({
  email: Joi.string().email({ tlds: false }).trim(),
  password: Joi.string().trim(),
});

const registerSchema = Joi.object({
  email: Joi.string().email({ tlds: false }).trim(),
});

export default Login;
